import { defineComponent as n, computed as d, provide as i, createElementBlock as l, openBlock as r, normalizeStyle as s, createBlock as m, createCommentVNode as c, createElementVNode as f, unref as p, normalizeClass as u, renderSlot as g } from "vue";
import { JSONtoNaiveVars as O } from "./highrise343.mjs";
import "./highrise27.mjs";
import { getSectionFooterThemeOverrides as v } from "./highrise395.mjs";
import { FOOTER_BUTTON_SIZE as y, FOOTER_SPACE_SIZE as h } from "./highrise396.mjs";
import { COMPONENT_NAME as z } from "./highrise178.mjs";
import E from "./highrise139.mjs";
const S = ["id"], N = n({
  name: z.SECTION_FOOTER,
  inheritAttrs: !1
}), A = /* @__PURE__ */ n({
  ...N,
  props: {
    id: {
      type: String,
      required: !0
    },
    horizontalPadding: {
      type: Boolean,
      default: !0
    },
    topPadding: {
      type: Boolean,
      default: !0
    },
    bottomPadding: {
      type: Boolean,
      default: !0
    },
    divider: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "lg"
    }
  },
  setup(e) {
    const t = e, a = d(() => ({
      ...O(v(t.size))
    }));
    return i("hr-section-footer-size", y[t.size]), i("hr-section-footer-gap", h[t.size]), (o, B) => (r(), l("div", {
      id: e.id,
      class: "hr-section-footer",
      style: s(a.value)
    }, [
      e.divider ? (r(), m(p(E), {
        key: 0,
        "title-placement": "right",
        "margin-bottom": !1,
        "margin-top": !1
      })) : c("", !0),
      f("div", {
        class: u([
          "action-items-container",
          e.horizontalPadding ? "horizontal-padding" : "",
          e.topPadding ? "top-padding" : "",
          e.bottomPadding ? "bottom-padding" : ""
        ])
      }, [
        g(o.$slots, "default", {}, void 0, !0)
      ], 2)
    ], 12, S));
  }
});
export {
  A as default
};
